
export const firstLoad = (state) => state.firstLoad
export const authed = (state) => state.authed
export const verified = (state) => state.verified
export const user = (state) => state.user
export const userProjects = (state) => state.userProjects
export const settings = (state) => state.settings
export const menuRightCls = (state) => state.menuRightCls
export const showAdmin = (state) => state.showAdmin



// WEBPACK FOOTER //
// ./src/store/modules/user/getters.js